import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

interface CreatePaymentIntentRequest {
  paymentMethodId?: string;
  userId?: string;
  discountCode?: string;
  productId?: string;
  name?: string;
  email?: string;
  /** One key per checkout attempt; reuse on retry of the same submit. */
  idempotencyKey?: string;
  /** Explorer: book event on same first invoice as membership */
  comboEventId?: number;
  comboEventEarlyBird?: boolean;
  /** event | mentor | mentee | venture — Stripe metadata */
  explorerFlow?: string;
  /** Stripe promotion for combo event ticket (Explorer + membership); separate from membership discountCode */
  comboEventStripeDiscountCode?: string;
}

export interface CreatePaymentIntentResponse {
  clientSecret?: string;
  /** Invoice already paid or £0 due — skip Stripe confirm on the client */
  noPaymentRequired?: boolean;
  customerId?: string;
  paymentMethodId?: string;
  subscriptionId?: string;
  status?: string;
}

export const useMakeSubscriptionPayment = (
  options?: UseMutationOptions<
    CreatePaymentIntentResponse,
    unknown,
    CreatePaymentIntentRequest,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: CreatePaymentIntentRequest) =>
      axiosInstance
        .post(getAPIURL("/SubscriptionPayment/create-subscription"), data)
        .then((res) => res.data),
  });
};
